import React, { useState } from "react"
import GenericModal from "../generic-modal/generic-modal"
import Button from "../../atoms/button/button"
import StandardModal from "../standard-modal/standard-modal"
import eyeIcon from "../../../assets/images/eye.svg"
import eyeIconClose from "../../../assets/images/eye_close.svg"
import "./restore-password-modal.scss"

import AuthService from "../../../services/auth-service"

const RestorePasswordModal = ({
  setCommondModal,
  resetPassword,
  inputValueOTP,
}) => {
  const [disabledBtn, setDisabledBtn] = useState(false)

  const [tempPassInput, setTempPassInput] = useState(
    resetPassword ? "" : localStorage.getItem("tempPass")
  )
  const [newPassInput, setNewPassInput] = useState("")

  const [seeTempPass, setSeeTempPass] = useState(false)
  const [seeNewPass, setSeeNewPass] = useState(false)

  const [errorEmptyTempPass, setErrorEmptyTempPass] = useState(false)
  const [errorEmptyNewPass, setErrorEmptyNewPass] = useState(false)

  const [errorTempPass, setErrorTempPass] = useState(false)
  const [errorNewPass, setErrorNewPass] = useState(false)

  const [copylevelSecurity, setCopyLevelSecurity] = React.useState("Débil")
  const [levelSecurity, setLevelSecurity] = React.useState(1)

  const [errorServer, setErrorServer] = React.useState(false)
  const [serverMessaje, setServerMessaje] = React.useState("")

  const reloadInfo = param => {
    //localStorage.removeItem('USER_INFO')
    window.location.reload()
  }

  const handleChangePassword = () => {
    //Validate empty inputs
    if (tempPassInput !== "" && newPassInput !== "") {
      setErrorEmptyTempPass(false)
      setErrorEmptyNewPass(false)

      if (/.{6,}$/.test(newPassInput)) {
        setErrorNewPass(false)
        setDisabledBtn(true)
        var payload
        var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
        var config = {
          headers: {
            Authorization: tokenId,
          },
        }
        if (resetPassword) {
          payload = {
            accessToken: JSON.parse(localStorage.getItem("TOKEN_INFO"))
              .accessToken,
            previousPassword: tempPassInput,
            proposedPassword: newPassInput,
            userCredential: JSON.parse(localStorage.getItem("USER_INFO")).email,
            otpKey: inputValueOTP,
          }

          AuthService.restorePassToken(payload, config)
            .then(res => {
              if (res.status === 200) {
                setErrorTempPass(false)
                setCommondModal(
                  <StandardModal
                    title="¡Se ha cambiado tu contraseña!"
                    subtitle=""
                    description="Continúa disfrutando de NosotrasOnline.com. y todos sus beneficios."
                    button_title="Perfecto"
                    click={reloadInfo}
                  />
                )
              } else if (res.status === 400) {
                setErrorServer(true)
                setDisabledBtn(false)
                setServerMessaje(res.userMessage)
              } else {
                setErrorServer(true)
                setDisabledBtn(false)
                setServerMessaje(res.userMessage)
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          payload = {
            accessToken: JSON.parse(localStorage.getItem("TOKEN_INFO"))
              .accessToken,
            previousPassword: tempPassInput,
            proposedPassword: newPassInput,
            userCredential: JSON.parse(localStorage.getItem("USER_INFO")).email,
          }

          AuthService.restorePass(payload, config)
            .then(res => {
              if (res.status === 200) {
                setErrorTempPass(false)
                setCommondModal(
                  <StandardModal
                    title="¡Se ha cambiado tu contraseña!"
                    subtitle=""
                    description="Continúa disfrutando de NosotrasOnline.com. y todos sus beneficios"
                    button_title="Perfecto"
                    click={reloadInfo}
                  />
                )
              } else if (res.status === 400) {
                setErrorServer(true)
                setDisabledBtn(false)
                setServerMessaje(res.userMessage)
              } else {
                setErrorServer(true)
                setDisabledBtn(false)
                setServerMessaje(res.userMessage)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      } else {
        setErrorNewPass(true)
      }
    } else {
      setErrorNewPass(false)
      setErrorEmptyNewPass(true)
    }
  }

  const validateSecuruty = e => {
    if (e.target.value.length > 5) {
      var numberSecurity = 0
      var val = e.target.value
      if (/[a-z]/.test(val)) {
        numberSecurity++
      }
      if (/[A-Z]/.test(val)) {
        numberSecurity++
      }
      if (/[0-9]/.test(val)) {
        numberSecurity++
      }
      if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(val)) {
        numberSecurity++
      }
      switch (numberSecurity) {
        case 1:
          setLevelSecurity(1)
          setCopyLevelSecurity("Débil")
          break
        case 2:
          setLevelSecurity(2)
          setCopyLevelSecurity("Medio")
          break
        case 3:
          setLevelSecurity(2)
          setCopyLevelSecurity("Medio")
          break
        case 4:
          setLevelSecurity(3)
          setCopyLevelSecurity("Fuerte")
          break

        default:
          setLevelSecurity(1)
          setCopyLevelSecurity("Débil")
          break
      }
    }
    setNewPassInput(e.target.value)
  }

  return (
    <GenericModal>
      <div className="f-modal-info">
        <div className="f-main-title-container">
          <label className="f-main-title">Crea una contraseña nueva</label>
        </div>

        <div className="f-form-container">
          {resetPassword && (
            <div className="f-group-input">
              <label className="f-label-form f-label-temp-pass">
                INGRESA TU ANTERIOR CONTRASEÑA
              </label>
              <div className="f-input-container">
                <input
                  className={
                    "f-input " +
                    ((errorTempPass || errorEmptyTempPass) && "f-error-input")
                  }
                  name="f-input-temp-pass"
                  type={seeTempPass ? "text" : "password"}
                  maxLength="99"
                  onChange={e => {
                    setErrorEmptyNewPass(false)
                    setErrorEmptyTempPass(false)
                    setErrorTempPass(false)
                    setErrorNewPass(false)
                    setErrorServer(false)
                    setTempPassInput(e.target.value)
                  }}
                />
                <span
                  className="f-icon icon-see-password f-icon-see"
                  onClick={() => setSeeTempPass(seeTempPass ? false : true)}
                />
              </div>
              <label className="f-input-error-label">
                {errorTempPass && "*Contraseña  incorrecta"}
                {errorEmptyTempPass && "*Campo requerido"}
              </label>
            </div>
          )}
          <div className="f-group-input">
            <label className="f-label-form f-label-new-pass">
              INGRESA TU NUEVA CONTRASEÑA
            </label>
            <div className="f-input-container">
              <input
                className={
                  "f-input " +
                  ((errorNewPass || errorEmptyNewPass) && "f-error-input")
                }
                name="f-input-new-pass"
                type={seeNewPass ? "text" : "password"}
                maxLength="99"
                // value={inputMailValue}
                onChange={e => validateSecuruty(e)}
              />
              <img
                className=" f-icon-see"
                src={seeNewPass ? eyeIconClose : eyeIcon}
                onClick={() => setSeeNewPass(seeNewPass ? false : true)}
              />
            </div>
            <div className="f-step-register-form-item-seguritypw">
              <span className="active" />
              <span className={levelSecurity > 1 ? "active" : ""} />
              <span className={levelSecurity > 2 ? "active" : ""} />
              <p>{copylevelSecurity}</p>
            </div>
            <label className="f-input-error-label">
              {errorNewPass && "*La contraseña no cumple con los criterios"}
              {errorEmptyNewPass && "*Campo requerido"}
            </label>
          </div>
          <label className="f-label-form-description">
            *La contraseña debe ser de mínimo 6 caracteres.
          </label>
          <br />
          <br />
          <label className="f-input-error-label">
            {errorServer && serverMessaje}
          </label>
        </div>

        <div
          className="f-button-action-container"
          onClick={() => handleChangePassword()}
        >
          <Button className="new-primary-pink short" title="Enviar" />

          {disabledBtn && (
            <div
              className="f-btn-disabled-mask"
              onClick={e => e.stopPropagation()}
            />
          )}
        </div>
      </div>
    </GenericModal>
  )
}

export default RestorePasswordModal
